
const digest = '0283cd77d8c102655626bc72b600a67b414e2d6005988726e291229af0208d43';
const classes = {"box":"_box_1kv36_1"};
const css = `._box_1kv36_1 {
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  